import { moduleLinks } from "../data/moduleLinks";

export const isValidLink = (): boolean => {
  // find module
  return !!moduleLinks.find((module) => module.path.includes(window.location.pathname.replaceAll("/", "")));
};
